
<!-- keyboardPress: Set custom functionality on keyboard press (i.e: prevent popup clonsing when enter is pressed)" -->
<!-- (keypress)="keyboardPress($event) | (keydown)="keyboardPress($event) | (keyup)="keyboardPress($event) -->
<div class="global-container" (keypress)="keyboardPress($event)" (keyup)="keyboardUp($event)">


    <div class="global-container-two-columns-split">

        <!-- Global column left -->
        <div class="global-container-column">

            <!-- Vertebral level slider -->
            <div class="single-action-container">
                <div class="columns-container" style="margin-top: 0px;">
                    <div class="column-left">
                        <!-- Title -->
                        <p class="single-action-title">
                            {{languageService.Strings.additionalDataPopupsStrings.slider_title_vertebral_levels}}
                        </p>
                    </div>
                    <!-- Slider bar values -->
                    <div class="column-right">
                        <p class="slide-value">{{getVertebralLevelStrValue()}}</p>
                    </div>
                </div>
                <!-- Custom slider -->
                <mat-slider 
                    showTickMarks
                    class="slider-bar"
                    [min]="0" 
                    [max]="valueList_vertebralLevels.length-1" >
                    <input matSliderStartThumb
                        [(ngModel)]="lowerSliderIndex_vertebralLevels"
                        (change)="sliderChange_vertebralLevel()">
                    <input matSliderEndThumb
                        [(ngModel)]="upperSliderIndex_vertebralLevels"
                        (change)="sliderChange_vertebralLevel()">
                </mat-slider>
            </div>

            <!-- Image quality slider -->
            <div class="single-action-container" style="margin-top: 0px;">
                <div class="columns-container">
                    <div class="column-left">
                        <!-- Title -->
                        <p class="single-action-title">
                            {{languageService.Strings.additionalDataPopupsStrings.slider_title_image_quality}}
                        </p>
                    </div>
                    <!-- Slider bar values -->
                    <div class="column-right">
                        <p class="slide-value">{{getImageQualityStrValue()}}</p>
                    </div>
                </div>
                <!-- Slider bar -->
                <mat-slider 
                    showTickMarks
                    class="slider-bar"
                    [min]="0" 
                    [max]="maxValue_imageQuality" 
                    [step]="1">
                    <input [(ngModel)]="sliderIndex_imageQuality" (change)="sliderChange_imageQuality()" matSliderThumb>
                </mat-slider> 
            </div>


            <!-- Artifacts boolean and slider -->
            <div class="single-action-container">
                <!-- Title -->
                <p class="single-action-title">
                    {{languageService.Strings.additionalDataPopupsStrings.title_segmentationDifficulty}}
                </p>
                <div class="columns-container">
                    <!-- Togle -->
                    <div class="column-left">
                        <div class="slide-toggle">
                            <mat-slide-toggle [(ngModel)]="slideToggle_segmentationDifficulty" >
                                &nbsp;&nbsp;&nbsp; {{ slideToggle_segmentationDifficulty ?
                                    languageService.Strings.additionalDataPopupsStrings.slide_toggle_booleans[1] :
                                    languageService.Strings.additionalDataPopupsStrings.slide_toggle_booleans[0]
                                }}
                            </mat-slide-toggle>
                        </div>
                    </div>
                    <!-- Slider bar value -->
                    <div class="column-right">
                        <p class="slide-value">{{getSegmentationDifficultyStrValue()}}</p>
                    </div>   
                </div>
                <!-- Slider bar -->
                <mat-slider 
                    showTickMarks
                    class="slider-bar"
                    [min]="0" 
                    [max]="maxValue_segmentationDifficulty" 
                    [step]="1"
                    [disabled]="!slideToggle_segmentationDifficulty">
                    <input [(ngModel)]="sliderIndex_segmentationDifficulty" (change)="sliderChange_segmentationDifficulty()" matSliderThumb>
                </mat-slider> 
            </div>

            <!-- Patient orientation slider -->
            <div class="single-action-container" style="margin-top: 0px;">
                <div class="columns-container">
                    <div class="column-left">
                        <!-- Title -->
                        <p class="single-action-title">
                            {{languageService.Strings.additionalDataPopupsStrings.slider_title_patient_orientation}}
                        </p>
                    </div>
                    <!-- Slider bar values -->
                    <div class="column-right">
                        <p class="slide-value">{{getPatientOrientationStrValue()}}</p>
                    </div>
                </div>
                <!-- Slider bar -->
                <mat-slider 
                    showTickMarks
                    class="slider-bar"
                    [min]="0" 
                    [max]="maxValue_patientOrientation" 
                    [step]="1">
                    <input [(ngModel)]="sliderIndex_patientOrientation" (change)="sliderChange_patientOrientation()" matSliderThumb>
                </mat-slider> 
            </div>

        
            <!-- Intravenous contrast boolean and slider -->
            <div class="single-action-container">
                <!-- Title -->
                <p class="single-action-title">
                    {{languageService.Strings.additionalDataPopupsStrings.title_ivContrast}}
                </p>
                <div class="columns-container">
                    <!-- Togle -->
                    <div class="column-left">
                        <div class="slide-toggle">
                            <mat-slide-toggle [(ngModel)]="slideToggle_ivContrast" >
                                &nbsp;&nbsp;&nbsp; {{ slideToggle_ivContrast ?
                                    languageService.Strings.additionalDataPopupsStrings.slide_toggle_booleans[1] :
                                    languageService.Strings.additionalDataPopupsStrings.slide_toggle_booleans[0]
                                }}
                            </mat-slide-toggle>
                        </div>
                    </div>
                    <!-- Slider bar value -->
                    <div class="column-right">
                        <p class="slide-value">{{getIvContrastLevelStrValue()}}</p>
                    </div>   
                </div>
                <!-- Slider bar -->
                <mat-slider 
                    showTickMarks
                    class="slider-bar"
                    [min]="0" 
                    [max]="valueList_ivContrastLevel.length - 1" 
                    [step]="1"
                    [disabled]="!slideToggle_ivContrast">
                    <input [(ngModel)]="sliderIndex_ivContrastLevel" (change)="sliderChange_ivContrastLevel()" matSliderThumb>
                </mat-slider> 
            </div>

        </div>


        <!-- Global column right -->
        <div class="global-container-column">

            <!-- Artifacts boolean and slider -->
            <div class="single-action-container">
                <!-- Title -->
                <p class="single-action-title">
                    {{languageService.Strings.additionalDataPopupsStrings.title_nArtifactRanges}}
                </p>
                <div class="columns-container">
                    <!-- Togle -->
                    <div class="column-left">
                        <div class="slide-toggle">
                            <mat-slide-toggle [(ngModel)]="slideToggle_nArtifactRanges" >
                                &nbsp;&nbsp;&nbsp; {{ slideToggle_nArtifactRanges ?
                                    languageService.Strings.additionalDataPopupsStrings.slide_toggle_booleans[1] :
                                    languageService.Strings.additionalDataPopupsStrings.slide_toggle_booleans[0]
                                }}
                            </mat-slide-toggle>
                        </div>
                    </div>
                    <!-- Slider bar value -->
                    <div class="column-right">
                        <p class="slide-value">{{getNArtifactRangesStrValue()}}</p>
                    </div>   
                </div>
                <!-- Slider bar -->
                <mat-slider 
                    showTickMarks
                    class="slider-bar"
                    [min]="0" 
                    [max]="maxValue_nArtifactRanges" 
                    [step]="1"
                    [disabled]="!slideToggle_nArtifactRanges">
                    <input [(ngModel)]="sliderIndex_nArtifactRanges" (change)="sliderChange_nArtifactRanges()" matSliderThumb>
                </mat-slider> 
            </div>

            <!-- Overflow boolean and slider -->
            <div class="single-action-container">
                <!-- Title -->
                <p class="single-action-title">
                    {{languageService.Strings.additionalDataPopupsStrings.title_nOverflowRanges}}
                </p>
                <div class="columns-container">
                    <!-- Togle -->
                    <div class="column-left">
                        <div class="slide-toggle">
                            <mat-slide-toggle [(ngModel)]="slideToggle_nOverflowRanges" >
                                &nbsp;&nbsp;&nbsp; {{ slideToggle_nOverflowRanges ?
                                    languageService.Strings.additionalDataPopupsStrings.slide_toggle_booleans[1] :
                                    languageService.Strings.additionalDataPopupsStrings.slide_toggle_booleans[0]
                                }}
                            </mat-slide-toggle>
                        </div>
                    </div>
                    <!-- Slider bar value -->
                    <div class="column-right">
                        <p class="slide-value">{{getNOverflowRangesStrValue()}}</p>
                    </div>   
                </div>
                <!-- Slider bar -->
                <mat-slider 
                    showTickMarks
                    class="slider-bar"
                    [min]="0" 
                    [max]="maxValue_nOverflowRanges" 
                    [step]="1"
                    [disabled]="!slideToggle_nOverflowRanges">
                    <input [(ngModel)]="sliderIndex_nOverflowRanges" (change)="sliderChange_nOverflowRanges()" matSliderThumb>
                </mat-slider> 
            </div>
            
            <!-- Oral contrast boolean and slider -->
            <div class="single-action-container">
                <div class="columns-container">
                    <div class="column-left">
                        <!-- Title -->
                        <p class="single-action-title">
                            {{languageService.Strings.additionalDataPopupsStrings.title_oContrast}}
                        </p>
                    </div>
                    <!-- Togle -->
                    <div class="column-right">
                        <div class="slide-toggle-right">
                            <mat-slide-toggle [(ngModel)]="slideToggle_oContrast" >
                                &nbsp;&nbsp;&nbsp; {{ slideToggle_oContrast ?
                                    languageService.Strings.additionalDataPopupsStrings.slide_toggle_booleans[1] :
                                    languageService.Strings.additionalDataPopupsStrings.slide_toggle_booleans[0]
                                }}
                            </mat-slide-toggle>
                        </div>
                    </div>  
                </div>
                <!-- Checklist options -->
                <mat-selection-list
                    class="custom-selection-list"
                    [(ngModel)]="selectedOptions_oContrast"
                    (selectionChange)="selectionChange_oContrastLevel()" 
                    [disabled]="!slideToggle_oContrast"
                    [compareWith]="compareOptions">
                        <mat-list-option 
                            class="custom-selection-option"
                            *ngFor="let option of languageService.Strings.additionalDataPopupsStrings.list_options_oContrast; let i = index"
                            [value]="i">
                            {{ option }}
                        </mat-list-option>
                </mat-selection-list>
            </div>

        </div>

    </div>

    <!-- Actions -->
    <div class="base_buttons_container">
        <!-- Exit button --> 
        <button mat-raised-button color="primary" class="base_buttons" (click)="exitButtonClicked()" style="width: 47%;">
            {{languageService.Strings.buttons.button_exit}}
        </button>  
        <!-- Save button -->        
        <button mat-raised-button color="primary" class="base_buttons" (click)="saveButtonClicked()" style="width: 47%;"
                [disabled]="!getInfoIsValid() || !evaluateUnsavedChanges()"> 
            {{languageService.Strings.buttons.button_save}}
        </button>   
    </div>

</div>


